/**
 * Unique identifier for each guide in the system.
 * Used as keys in completion/step tracking and to determine which guide component to render.
 */
enum GuideId {
    bomPdf = 'bom-pdf',
    bomOverview = 'bom-overview',
    createEditBom = 'create-edit-bom',
    bomPurchaseOrders = 'bom-purchase-orders',
}

/**
 * Human-readable label for each guide.
 * `Record<GuideId, string>` forces every guide to be labelled at compile time.
 */
const GUIDE_LABELS: Record<GuideId, string> = {
    [GuideId.bomOverview]: 'BOM overview guide',
    [GuideId.createEditBom]: 'Create/edit BOM guide',
    [GuideId.bomPurchaseOrders]: 'BOM & purchase orders guide',
    [GuideId.bomPdf]: 'BOM PDF guide',
};

export { GUIDE_LABELS, GuideId };
